import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-communication-records',
  templateUrl: './communication-records.component.html',
  styleUrls: ['./communication-records.component.scss']
})
export class CommunicationRecordsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
